import { apiClient } from './client';
import type {
  Export,
  ExportType,
  CreateExportData,
  CreateExportResponse,
} from '@/types/admin-export';

export async function getExportTypes(): Promise<ExportType[]> {
  const response = await apiClient.get<ExportType[]>('/api/admin/exports/types');
  return response.data;
}

export async function getExports(): Promise<Export[]> {
  const response = await apiClient.get<Export[]>('/api/admin/exports');
  return response.data;
}

export async function createExport(data: CreateExportData): Promise<CreateExportResponse> {
  const response = await apiClient.post<CreateExportResponse>('/api/admin/exports', data);
  return response.data;
}

export async function getExportStatus(id: number): Promise<Export> {
  const response = await apiClient.get<Export>(`/api/admin/exports/${id}`);
  return response.data;
}

export async function processExport(id: number): Promise<Export> {
  const response = await apiClient.post<Export>(`/api/admin/exports/${id}/process`);
  return response.data;
}

export async function deleteExport(id: number): Promise<{ message: string }> {
  const response = await apiClient.delete<{ message: string }>(`/api/admin/exports/${id}`);
  return response.data;
}

export function getExportDownloadUrl(id: number): string {
  const baseUrl = import.meta.env.VITE_API_URL || 'http://localhost:8092';
  return `${baseUrl}/api/admin/exports/${id}/download`;
}

export async function customSqlExport(sql: string): Promise<void> {
  const response = await apiClient.post('/api/admin/exports/custom-sql', { sql }, {
    responseType: 'blob',
  });

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `export_ef_${new Date().toISOString().slice(0, 10)}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
